<template>
<el-dropdown @command="handleLang" trigger="click">
  <span class="el-dropdown-link lang">
    {{langList[$i18n.locale]}}<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
  <el-dropdown-menu slot="dropdown">
    <el-dropdown-item v-for="(value,key) in localList" :key="key" :command="key">{{value}}</el-dropdown-item>
  </el-dropdown-menu>
</el-dropdown>
</template>

<script>
import {
  mapMutations
} from 'vuex';
export default {
  name: '',
  data() {
    return {
      langList: {
        'zh-CN': '语言',
        'zh-TW': '語言',
        'en-US': 'Lang'
      },
      localList: {
        'zh-CN': '中文简体',
        'zh-TW': '中文簡體',
        'en-US': 'English'
      }
    }
  },
  methods: {
    ...mapMutations(['setLang']),
    handleLang(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('local', lang)
      this.setLang(lang)
      this.$emit('change', lang)
    }
  }
}
</script>

<style lang="less" scoped>
.el-dropdown {
  font-family: "微软雅黑";
  .lang {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/lang.vue